export const MAX_AMOUNT = 400000
export const MIN_AMOUNT = 10000
export const MAX_REPAYMENT_PERIODS = 180
export const MIN_REPAYMENT_PERIODS = 12
export const DEFAULT_REPAYMENT_PERIODS = 12 * 15
export const DEFAULT_AMOUNT = 10000
export const INTEREST_RATE_HANDLARFINANS = 9.95
export const INTEREST_RATE_DEFAULT = 10.2
